module.exports = {
	messages: [],
	sent_messages: [],
	recipients: null,
};